import { SkillIdsTable } from './SkillIdTable';
import { SkillsSearchTermTable } from './SkillsSearchTermTable';
import { useGlobalSearchTableParams } from '../../../global-search/use-global-search-table-params';

import type { FunctionComponent } from 'react';

export const SkillsTable: FunctionComponent = () => {
    const { isValidSearchTerm, isValidSkillIdsList, searchTermResult, skillIds } = useGlobalSearchTableParams();

    if (isValidSkillIdsList) {
        return <SkillIdsTable skillIds={skillIds} />;
    }

    if (isValidSearchTerm) {
        return <SkillsSearchTermTable searchTerm={searchTermResult} />;
    }

    return null;
};
